export default {
  title: "Risk Index",
  items: {
    noData: "No data",
    invalidArea: "Invalid area"
  },
  footer: "Scale: 1-10 (low to high values)"
}
